export default "__VITE_ASSET__BdgAjJh3__"